import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/context/LanguageContext";
import { SettingsProvider } from "@/context/SettingsContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import AiChatWidget from "@/components/AiChatWidget";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Track from "@/pages/Track";
import ClientSpace from "@/pages/ClientSpace";
import EstimatePage from "@/pages/EstimatePage";
import News from "@/pages/News";
import NewsArticle from "@/pages/NewsArticle";
import History from "@/pages/History";
import Recruit from "@/pages/Recruit";
import Vehicles from "@/pages/Vehicles";
import VehiclePage from "@/pages/VehiclePage";
import { VisitTracker } from "@/components/VisitTracker";
import { Toaster } from "@/components/ui/sonner";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    window.__lenis = lenis;
    return () => {
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <SettingsProvider>
        <BrowserRouter>
          <ScrollManager />
          <VisitTracker />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/histoire" element={<History />} />
            <Route path="/recrutement" element={<Recruit />} />
            <Route path="/vehicules" element={<Vehicles />} />
            <Route path="/vehicules/:id" element={<VehiclePage />} />
            <Route path="/galerie" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/suivi" element={<Track />} />
            <Route path="/mon-espace" element={<ClientSpace />} />
            <Route path="/mon-espace/:key" element={<ClientSpace />} />
            <Route path="/actualites" element={<News />} />
            <Route path="/actualites/:id" element={<NewsArticle />} />
            <Route path="/devis/:id" element={<EstimatePage />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/reset" element={<Admin />} />
          </Routes>
          <Footer />
          <WhatsAppFab />
          <AiChatWidget />
          <Toaster theme="light" position="bottom-center" richColors />
        </BrowserRouter>
        </SettingsProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
